import { MODULE } from '@core/configs';
import { environment } from '@environments/environment';

const isLocalOrIP = window.location.hostname === 'localhost' || 
                   /^192\.168\./.test(window.location.hostname) || 
                   /^10\./.test(window.location.hostname) || 
                   /^172\.(1[6-9]|2[0-9]|3[01])\./.test(window.location.hostname);


export const APP_CONFIG = {
  module: MODULE.careMoni,
  apiBaseUrl: environment.apiBaseUrl,
  tokenUrl: environment.tokenUrl,
  authUrl: environment.authUrl,
  inActiveTime: 30,
  useFirebase: isLocalOrIP ? false : environment.useFirebase,
  saucerLogUrl: environment.saucerLogApiUrl,
  saucerLogToken: environment.saucerLogToken
};
